import Api from 'src/api/Base'

class GetLatestSpacePlan extends Api {
  requestUrl = `/api/SpacePlan/Latest`
}

export default GetLatestSpacePlan
